import React, { useEffect, useState } from "react";
import Card from "components/card";
import { columnsDataCheckGateWay } from "../tables/variables/columnsData";
import { useDispatch, useSelector } from "react-redux";
import { MdSkipNext, MdSkipPrevious } from "react-icons/md";
import { notify } from "common/toastUtil";
import PopUpAlertModal from "components/modals/popUpAlertModal";
import AddPaymentModal from "components/modals/addPaymentModal";
import { getGateWayListThunk } from "slices/userSlice";
import GateWayTable from "../tables/components/GateWayTable";
import { deleteGateWayThunk } from "slices/userSlice";
const PaymentGatewayPage = () => {
    const appList = useSelector((state) => state?.users?.gatewayList) || [];
    console.log("appList",appList)
    const appdelete = useSelector((state) => state?.users?.data);
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [singleData, setSingleData] = React.useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [openAlert, setOpenAlert] = useState(false);
    const [id,setId]= useState("");
    const [dataTable, setDataTable] = useState(appList || []);
const itemsPerPage = 5; // adjust as needed
const indexLast = currentPage * itemsPerPage;
const indexFirst = indexLast - itemsPerPage;
const currentApps = dataTable?.slice(indexFirst, indexLast);

    const totalPages = Math.ceil(dataTable?.length / itemsPerPage);
    useEffect(() => {
        dispatch(getGateWayListThunk());
    }, []);
    const deleteApp = (id) => {
        setId(id);
        setOpenAlert(true);

    }

    useEffect(() => {
        if (appList?.length > 0) {
            setDataTable(appList);
        }
    }
        , [appList, appdelete?.status]);
            useEffect(() => {
        if (appdelete?.status === 200 && id && appdelete?.message=="Admin deleted successfully") {
            notify("success", appdelete?.message);
            setOpenAlert(false);
            dispatch(getGateWayListThunk());


        }
        if (appdelete?.status !== 200 && appdelete.status !==201) {
            notify("error", appdelete?.message);
        }
    }, [appdelete?.status,dispatch,appdelete?.message,id]);
    return (
        <>
 <div className="flex justify-around w-full mt-4">
  <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
    Total Gateway Count: {appList?.length ?? 0}
  </Card>

  <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
    Active Gateway Count: {appList?.filter(item => item?.is_active)?.length ?? 0}
  </Card>

  <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
    Inactive Gateway Count: {appList?.filter(item => !item.is_active)?.length ?? 0}
  </Card>
    <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
    Live Gateway Count: {appList?.filter(item => item.mode==="Live")?.length ?? 0}
  </Card>
    <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
    Test Gateway Count:  {appList?.filter(item => item.mode==="Test")?.length ?? 0}
  </Card>
</div>

        <PopUpAlertModal openAlert={openAlert} setOpenAlert={setOpenAlert} title="Are you sure you want to delete this gateway ?" clickHandler={()=>dispatch(deleteGateWayThunk(id))} />
        <AddPaymentModal open={open} setOpen={setOpen} singleData={singleData} setSingleData={setSingleData} />
            <Card extra="mt-3 !z-5 overflow-hidden">
                <div className="relative w-full flex items-center justify-end rounded-t-3xl p-3">
                    <button onClick={() => setOpen(true)}
                        className=" top-3 right-3 flex items-center justify-center rounded-[9px] bg-[#422afb] p-2 text-white hover:cursor-pointer"
                    >
                        Register New Payment GateWay
                    </button>


                </div>
            </Card>
            <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">

                {currentApps?.length >0 && <GateWayTable deleteApp={deleteApp} setOpen={setOpen} setSingleData={setSingleData} columnsData={columnsDataCheckGateWay} tableData={currentApps} />}
                <div className="flex gap-2 justify-center my-4">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((p) => p - 1)}
  >
    <MdSkipPrevious />
  </button>

  {[...Array(totalPages)].map((_, i) => {
    const page = i + 1;
    return (
      <button
        key={page}
        onClick={() => setCurrentPage(page)}
        className={page === currentPage ? 'font-bold' : ''}
      >
        {page}
      </button>
    );
  })}

  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage((p) => p + 1)}
  >
<MdSkipNext />
  </button>
</div>

            </div>
        </>

    );
};

export default PaymentGatewayPage
